export default "__VITE_ASSET__6fFf6J63__"